/* eslint-disable no-undef */
import React, {Component} from "react";
import {Checkbox, FormControl, FormControlLabel, FormGroup} from '@material-ui/core';
import 'react-tabs/style/react-tabs.css';
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {makeStyles} from "@material-ui/core/styles";
import Api from "../../../../../Services/Api";

const classes = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    formControl: {
        margin: theme.spacing(3),
    },
}));

class TabFormAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data ? props.data : {
                roleId: ""
            },
            dataRequest: [],
            formAccessData: []
        }
    }

    componentDidMount() {
        this.getFormAccess()
    }

    getFormAccess() {
        let payload = {
            roleId: this.state.data.roleId,
        }
        if (this.props.data.accessType === 'Allowed') {
            Api.create('MASTERDATA_EKSAD').postGetRoleFormAllowed(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            item.formAccess.map((itemAccess) => {
                                if (itemAccess.accessForm) {
                                    arrayDataRequest.push({
                                        roleId: itemAccess.roleId,
                                        companyId: this.state.data.companyId,
                                        formAccessId: itemAccess.formAccessId,
                                        status: "Active",
                                    })
                                }
                            })
                        })
                        this.setState({
                            formAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        } else {
            Api.create('MASTERDATA_EKSAD').postGetRoleFormBanned(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            item.formAccess.map((itemAccess) => {
                                if (itemAccess.accessForm) {
                                    arrayDataRequest.push({
                                        roleId: itemAccess.roleId,
                                        companyId: this.state.data.companyId,
                                        formAccessId: itemAccess.formAccessId,
                                        status: "Active",
                                    })
                                }
                            })
                        })
                        this.setState({
                            formAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        }
    }

    onCheckAccess(itemData, itemAccess) {
        let dataArray = [...this.state.formAccessData];
        let objIndex = dataArray.findIndex((obj => obj.formId === itemData.formId));

        let dataAccess = dataArray[objIndex].formAccess;
        let objIndexAccess = dataAccess.findIndex((obj => obj.description === itemAccess.description))
        if (itemAccess.accessForm === false) {
            dataAccess[objIndexAccess].accessForm = true
            this.setState({
                formAccessData: dataArray,
            })
            this.state.dataRequest.push({
                roleId: dataAccess[objIndexAccess].roleId,
                companyId: this.state.data.companyId,
                formAccessId: dataAccess[objIndexAccess].formAccessId,
                status: "Active",
            })
        } else {
            dataAccess[objIndexAccess].accessForm = false
            this.setState({
                formAccessData: dataArray,
            })
            let index = this.state.dataRequest.findIndex((obj => obj.formAccessId === dataAccess[objIndexAccess].formAccessId));
            this.state.dataRequest.splice(index, 1);
        }
        this.props.requestData(this.state.dataRequest);
    }

    render() {
        return (
            <div style={{width: '95%', height: '40%'}}>
                {this.state.formAccessData.map((itemData, i) => {
                    return (
                        <div key={i}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>{itemData.menuForm}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="grid grid-2x" style={{width: '50%'}}>
                                        {itemData.formAccess.map((itemAccess, i) => {
                                            return (
                                                <div key={i}>
                                                    <FormControl required component="fieldset"
                                                                 className={classes.formControl}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={
                                                                    <div style={{flexWrap: 'wrap'}}>
                                                                        <Checkbox
                                                                            style={{color: 'grey'}}
                                                                            checked={itemAccess.accessForm}
                                                                            onChange={() => this.onCheckAccess(itemData, itemAccess)}
                                                                            disabled={this.props.type === "view"}
                                                                        />
                                                                    </div>
                                                                }
                                                                label={<span
                                                                    style={{fontSize: '15px'}}>{itemAccess.description}</span>}
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default TabFormAccess;